import {createSelector} from "reselect";
import {RootState} from "../../../types";
import {InvolvingPost} from "../types";

const select_items = (state: RootState) => state.involvingPosts.result;

const selectFiltered = createSelector([select_items], (items: InvolvingPost[]) => {
    return items;
});

export default selectFiltered;
